"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Eventinquiryhero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="262942" id="eventinquiryhero" className="bg-background text-foreground py-20 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(244,197,207,0.1)_0%,transparent_100%)] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-primary text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6">
            Ready to Bloom at Your Next Event?
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-3xl mx-auto mb-10 leading-relaxed">
            Share your event details with us and let's create a dreamy, interactive floral experience your guests will never forget. From weddings to pop-ups, we bring the beauty to you.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 shadow-md rounded-lg text-base h-14 px-8 font-default">
              <Link to="/ContactPage">
                INQUIRE ABOUT YOUR DATE
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-secondary text-secondary-foreground hover:bg-secondary/10 bg-transparent rounded-lg text-base h-14 px-8 font-default">
              <Link to="/PackagesPage">
                <Phone className="mr-2 size-5" />
                VIEW OUR PACKAGES
              </Link>
            </Button>
          </div>
        </div>
      </div>
      
      {/* Subtle champagne gold divider element */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1/3 h-px bg-gradient-to-r from-transparent via-secondary/30 to-transparent" />
    </section>;
}